import * as React from "react";
const SvgToastIconError = (props) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={20} height={20} rx={4} fill="#FF5B5B" />
    <g clipPath="url(#toast-icon-error_svg__a)">
      <g clipPath="url(#toast-icon-error_svg__b)">
        <g clipPath="url(#toast-icon-error_svg__c)">
          <path
            d="M10 3.333A6.66 6.66 0 0 0 3.333 10 6.66 6.66 0 0 0 10 16.667 6.66 6.66 0 0 0 16.667 10 6.66 6.66 0 0 0 10 3.333Zm2.867 9.534c-.26.26-.68.26-.94 0L10 10.94l-1.927 1.927a.664.664 0 1 1-.94-.94L9.06 10 7.133 8.073a.664.664 0 1 1 .94-.94L10 9.06l1.927-1.927a.664.664 0 1 1 .94.94L10.94 10l1.927 1.927a.676.676 0 0 1 0 .94Z"
            fill="#fff"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="toast-icon-error_svg__a">
        <path fill="#fff" transform="translate(2 2)" d="M0 0h16v16H0z" />
      </clipPath>
      <clipPath id="toast-icon-error_svg__b">
        <path fill="#fff" transform="translate(2 2)" d="M0 0h16v16H0z" />
      </clipPath>
      <clipPath id="toast-icon-error_svg__c">
        <path fill="#fff" transform="translate(2 2)" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgToastIconError;
